// eslint-disable-next-line import/prefer-default-export
export enum WORKSHOP_TYPES_ENUMS {
  WORKSHOP = 'WORKSHOP',
  WORKSHOP_RECORDING = 'WORKSHOP_RECORDING',
  B2B_WORKSHOP_PROMO = 'B2B_WORKSHOP_PROMO'
}
